import { useTheme } from "@emotion/react";
import { List, ListItem, ListItemText, Skeleton } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import FriendListItem from "components/talk/FriendListItem";

export default function FriendsList({
  onSelect = () => {},
}) {

  const theme = useTheme();

  const friendsState = useSelector((state) => state.collections.friends);

  const renderFriends = () => {
    if (!friendsState || friendsState.loading) {
      return Array.from(Array(3)).map((x, index) => (
        <ListItem key={`friend-skeleton-${index}`}>
          <ListItemText
            primary={<Skeleton variant="text" />}
            secondary={<Skeleton variant="text" />}
          />
        </ListItem>
      ));
    }
    const friends = friendsState.documents;
    if (friends.length === 0) {
      return (
        <ListItem>
          <ListItemText
            sx={{
              color: theme.palette.text.main,
            }}
          >
            No friends
          </ListItemText>
        </ListItem>
      );
    }
    return friends.map((friend) => (
      <FriendListItem 
        key={friend.id} 
        friend={friend}
        onSelect={onSelect}
      />
    ));
  };

  return (
    <List
      sx={{
        overflowX: "hidden",
      }}
    >
      {renderFriends()}
    </List>
  );
}
